import React, { useEffect, useState } from "react";
import { fetchEntityById } from "../../../apis/apiService";
import { useParams } from "react-router-dom";


const MilestoneSubTaskStatusTimeline = () => {
  const { id: taskId } = useParams();
  const [timeline, setTimeLine] = useState([]);
  const FetchMilestoneTimeline = async () => {
    try {
      const response = await fetchEntityById( "milestones/task/timeline", taskId );
      setTimeLine(response.elapsed_time);
      //console.log()("timeline_milestone_response :", response);
    } 
    catch (err) {
      console.error("error in milestone task timeline :", err);
    }
  };
  useEffect(() => {
    FetchMilestoneTimeline();
  }, [taskId]);
  
  return (
    <div className="py-3">
      <div
        className="d-flex justify-content-center align-items-center border  rounded"
        style={{ padding: "84px" }}
      >
        <button className="add_btn">Active</button>

        <div
          className="text-center p-3"
          style={{
            borderBottom: "2px dashed ",
            marginTop: "-55px",
            width: "415px",
          }}
        >
          <span>{timeline ? timeline : "Date is not set"}</span>
        </div>

        <span className="text-rgbr-red">Yet to close</span>
      </div>
    </div>
  );
};

export default MilestoneSubTaskStatusTimeline;
